import i18n from 'i18next';

const TitleAlert = (testType) => {

    if (testType === 1 || testType === 3) {
        return i18n.t('confirm_submit_1');
    }
    if (testType === 2) {
        return i18n.t('confirm_submit_2');
    }
    return i18n.t('confirm_submit_3');
};

export default TitleAlert;